var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBitcoinRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.47 12.048-.46.46v-.51c0-5.52-4.49-10.01-10.01-10.01-3.05 0-5.9 1.37-7.81 3.75-.26.32-.21.8.12 1.06.32.25.79.2 1.05-.12A8.476 8.476 0 0 1 12 3.488c4.69 0 8.51 3.82 8.51 8.51v.5l-.46-.46a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.74 1.74a.776.776 0 0 0 .53.22.753.753 0 0 0 .53-.22l1.74-1.74c.29-.28.29-.76 0-1.05a.754.754 0 0 0-1.06 0zM18.64 17.32A8.476 8.476 0 0 1 12 20.51c-4.69 0-8.51-3.82-8.51-8.51v-.5l.46.46c.15.15.34.22.53.22s.38-.08.52-.23c.29-.29.29-.77 0-1.06L3.27 9.15c-.07-.06-.16-.12-.25-.16a.707.707 0 0 0-.57 0c-.09.04-.17.1-.24.16L.47 10.89c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0l.46-.46V12c0 5.52 4.49 10.01 10.01 10.01 3.05 0 5.9-1.37 7.81-3.75a.75.75 0 0 0-.12-1.06.738.738 0 0 0-1.05.12z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.87 10.25c0-1.33-1.17-2.5-2.5-2.5h-.82v-1c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1H9c-.41 0-.75.34-.75.75v7c0 .41.34.75.75.75h2.05v1c0 .41.34.75.75.75s.75-.34.75-.75v-1H14c1.52 0 2.75-1.12 2.75-2.5 0-.89-.52-1.67-1.3-2.11.27-.4.42-.87.42-1.39zm-2.5-1c.55 0 1 .55 1 1 0 .55-.45 1-1 1H9.75v-2h3.62zm-3.62 5.5v-2H14c.69 0 1.25.45 1.25 1s-.56 1-1.25 1H9.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBitcoinRefresh);
export default __webpack_public_path__ + "static/media/vuesax-bold-bitcoin-refresh.51e437b965597fd283a4f0a063d58c04.svg";
export { ForwardRef as ReactComponent };